const embedSafeCopyToClipboard = (text: string): boolean => {
    let copied = false;
    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.opacity = "0";
    textArea.style.position = "absolute";
    textArea.style.left = "-9999px";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
        document.execCommand("copy");
        copied = true;
    } catch (err) {
        console.error("Error copying to clipboard (embed safe)", err);
    }

    document.body.removeChild(textArea);

    return copied;
};

export const copyToClipboard = async (text: string): Promise<boolean> => {
    let copied = false;
    try {
        if (
            !navigator?.clipboard?.writeText ||
            typeof navigator.clipboard.writeText !== "function"
        ) {
            throw new Error("Clipboard API not available");
        }

        await navigator.clipboard.writeText(text);
        copied = true;
    } catch (err) {
        console.warn("Error copying to clipboard", err);
        copied = embedSafeCopyToClipboard(text);
    }

    return copied;
};
